rdefine("app/clients/Configurator",['backbone',
    'text!clients/configurator.html',
    'app/components/SelectOption',
    'app/clients/LanguageForm',
    'app/clients/PropertyDisplay',
    'text!clients/configurator-oauth-row.html',
    'app/components/SelectPicker',
    'app/clients/ConfigureMessageTab',
    'app/components/TableBJS',
    'app/clients/PropertyModal',
    'text!clients/tablerow.html'],
    function(Backbone, template, SelectOption, LanguageForm,PropertyDisplay, oauthTemplate, SelectPicker, ConfigureMessageTab, TableBJS, PropertyModal, TableRowTemplate) {

        /*this.ptable = new TableBJS({
                    columns:[
                        {
                            title:LANGUAGE['clients.config.ptable.name'],
                            field:'names',
                            processor: function(langname) {
                                return langname && langname[CURRENT_LOCALE] ? langname[CURRENT_LOCALE] : '-';
                            }
                        },
                        {
                            title:LANGUAGE['clients.config.ptable.type'],
                            field:'type',
                            processor: function(type) {
                                return LANGUAGE['clients.config.props.types.'+type];
                            }
                        },
                        {
                            title:LANGUAGE['clients.config.ptable.required'],
                            field:'required',
                            processor: function(req) {
                                return LANGUAGE[req?'standart.yes':'standart.no'];
                            }
                        },
                        {
                            title:LANGUAGE['clients.config.ptable.visible'],
                            field:'visible',
                            processor: function(vis) {
                                return LANGUAGE[vis?'standart.yes':'standart.no'];
                            }
                        },
                        {
                            title:LANGUAGE['clients.config.ptable.edit'],
                            type:'icon',
                            icon:'edit',
                            action:this.onEditProp.bind(this)
                        },
                        {
                            title:LANGUAGE['basic.delete'],
                            type:'icon',
                            icon:'delete',
                            color:'danger',
                            toggle:'default',
                            action:this.onDeleteClick.bind(this)
                        }
                    ],
                    collection:this.props
                });*/

        var DataRowBindings = {
            '.name':{
                text:{
                    data:'model.names',
                    processor: function(langname) {
                        return langname && langname[CURRENT_LOCALE] ? langname[CURRENT_LOCALE] : '-';
                    }
                }
            },
            '.type':{
                text:{
                    data:'model.type',
                    processor: function(type) {
                        return LANGUAGE['clients.config.props.types.'+type];
                    }
                }
            },
            '.required':{
                text:{
                    data:'model.required',
                    processor: function(vis) {
                        return LANGUAGE[vis?'standart.yes':'standart.no'];
                    }
                }
            },
            '.visible':{
                text:{
                    data:'model.visible',
                    processor: function(vis) {
                        return LANGUAGE[vis?'standart.yes':'standart.no'];
                    }
                }
            },
            '.edit button':{
                toggle:{
                    data:'model.defs',
                    processor: function(a) { return !a; }
                }
            },
            '.delete button':{
                toggle:{
                    data:'model.defs',
                    processor: function(a) { return !a; }
                }
            },
            el:{
                attr:{
                    'data-id':{
                        data:['model.id','model.cid'],
                        processor: function(id,cid) {
                            if(id) {
                                return id;
                            }
                            return this.model.cid;
                        }
                    }
                }/*,
                css:{
                    'margin-left':{
                        data:'model.parent_id',
                        processor:function(parent_id) {
                            return parent_id ? '30px' : 0;
                        }
                    }
                }*/
                ,classes:{
                    'child-lit':{
                        data:'model.parent_id',
                        processor:function(parent_id) {
                            return parent_id ? '30px' : 0;
                        }
                    }
                }
            }
        };

    var DumbTableRow = Backbone.Ribs.View.extend({
        tagName:'li',
        className:'st-row',
        bindings:{},
        events:{
            "click .edit button":"onEdit",
            "click .delete button":"onDelete"
        },
        cmodel:null,
        initialize:function() {
            this.cmodel = this.collection.cmodel;
            this.$el.html(TableRowTemplate);
            this.bindings = _.clone(DataRowBindings);

            if(this.model.has("login_processor")) {
                this.bindings['.name'] = {
                    text:{
                        data:['cmodel.config_login_field_type','cmodel.login_field_names'],
                        processor:function(a,b) {
                            if(a==='custom') {
                                return b[CURRENT_LOCALE];
                            }

                            return LANGUAGE['clients.config.'+a];
                        }
                    }
                };

                this.bindings['.type']= {
                    text:{
                        data:'cmodel.config_login_field_type',
                        processor:function(a) {
                            return LANGUAGE['clients.config.'+a];
                        }
                    }
                };
            }else{
                this.bindings['.name'] = {
                    text:{
                        data:'model.names',
                        processor: function(langname) {
                            return langname && langname[CURRENT_LOCALE] ? langname[CURRENT_LOCALE] : '-';
                        }
                    }
                };

                this.bindings['.type']= {
                    text:{
                        data:'model.type',
                        processor: function(type) {
                            return LANGUAGE['clients.config.props.types.'+type];
                        }
                    }
                };
            }

            if(this.model.has("email_processor")) {
                this.bindings['el'] = {
                    classes:{
                        hidden: {
                            data: 'cmodel.config_login_field_type',
                            processor: function (a) {
                                return a === 'email';
                            }
                        }
                    },
                    attr:{
                        'data-id':{
                            data:['model.id','model.cid'],
                            processor: function(id,cid) {
                                if(id) {
                                    return id;
                                }
                                return cid;
                            }
                        }
                    }
                }
            }

            this.addBindings(this.bindings);
        },
        onEdit:function(){
            this.model.collection.onEdit(this.model);
        },
        onDelete:function(){
            this.model.collection.onDelete(this.model);
        }
    });

    var configModel = Backbone.Ribs.Model.extend({
        defaults:{
            enabled:false,
            register:true,
            loginfirst:false,
            sms_activation:false,
            public_profiles:false,
            allow_password_change:false,
            allow_edit_profile:false,
            premoderation:true,
            config_login_field_type:'email',
            custom_login_field:{},
            login_field_icon:null,
            properties:[],
            oauth:false,
            services:[]
        }
    });

    var propertyModel = Backbone.Ribs.Model.extend({
        defaults:{
            id:0,
            type:'string',
            names:{},
            required:false,
            visible:true,
            options:[],
            icon:'',
            parent_id:0
        },
        reset:function() {
            this.set(this.defaults);
        }
    });
    var serviceTableViewOrder =0;

    var serviceTableView = Backbone.Ribs.View.extend({
        tagName:'div',
        className:'row',
        bindings:{
            '.col-sm-6':{
                text: {
                    data:'model.oauth',
                    processor: function(oauth) {
                        return _L('clients.config.oauth.service.'+oauth);
                    }
                }
            },
            '.oauth_service_enabled': {
                checked:'model.enabled'
            }
        },
        events:{
            'click .btn-primary':'onEditClick'
        },
        initialize:function() {
            this.$el.html(Template7.compile(oauthTemplate)({order: serviceTableViewOrder++}));
            this.model.on("change",function(){
                this.collection.trigger('pack-data');
            }.bind(this));
        },
        onEditClick: function() {
            this.collection.trigger('open-modal', this.model, this.onSave.bind(this));
        },
        onSave:function(model) {
            this.model.set(model.attributes);
            return false;
        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'clients-configurator-wrap',
        bindings:{
            '#client_config_register':{
                checked:'model.register'
            },
            '#client_config_clientsenabled':{
                checked:'model.enabled'
            },
            '#client_config_premoderation':{
                checked:'model.premoderation'
            },
            '#client_config_sms':{
                checked:'model.sms_activation'
            },
            '#client_public_profiles':{
                checked:'model.public_profiles'
            },
            '#client_allow_password_change':{
                checked:'model.allow_password_change'
            },
            '#client_allow_edit_profile':{
                checked:'model.allow_edit_profile'
            },
            '.show-register-enabled':{
                toggle:'model.register'
            },
            //
            '.show-if-enabled-clients':{
                toggle:'model.enabled'
            },
            '.custom_login_show':{
                classes:{
                    hidden:{
                        processor:function(a){ return a!=='custom';},
                        data:'model.config_login_field_type'
                    }
                }
            },
            '#client_config_loginfirst':{
                checked:'model.loginfirst'
            },
           /* "select[name=config_login_field_type]":{
                value:{
                    events: ' change',
                    data:'model.config_login_field_type'
                },
                collection:{
                    col:'config_login_field_type',
                    view:SelectOption
                }
            },*/
            ".cancel-button":{
                attr:{
                    href:{
                        data:'opts.backurl'
                    }
                }
            },
            '.custom-property-list':{
                collection:{
                    col:'props',
                    view:PropertyDisplay
                }
            },
            //services
            '.oauth-table-service-list':{
                collection:{
                    col:'services',
                    view:serviceTableView
                },
                toggle:{
                    data:'model.oauth'
                }
            },
            '.none-oauth-display':{
                toggle:{
                    data:'model.availservices',
                    processor:function(a) { return !a; }
                }
            },
            '.config-service-modal .modal-title':{
                text:'modal.title'
            },
            '.config-service-modal .btn-primary':{
                text:'modal.action'
            },
            '.oauth-enabled-table-place':{
                toggle:'opts.oauth'
            },
            '#clients_oauth_enabled':{
                checked:'model.oauth'
            },
            '.oauth_service_secret_modal':{
                value:'service.secret'
            },
            '.oauth_service_key_modal':{
                value:'service.key'
            },
            '.oauth_service_enabled_modal':{
                checked:'service.enabled'
            },
            '.login_field_icon':{
                valueCustom:'model.login_field_icon'
            },
            '.props-table-place-list .super-table-rows':{
                collection:{
                    col:'props',
                    view:DumbTableRow
                }
            },
            '.login-is-email':{
                toggle:{
                    data:'model.config_login_field_type',
                    processor: function(a) {
                        return a!=='email';
                    }
                }
            },
            '.login-field-place':{
                text:{
                    data:['model.config_login_field_type','model.login_field_names'],
                    processor:function(a,b) {
                        if(a==='custom') {
                            return b[CURRENT_LOCALE];
                        }

                        return LANGUAGE['clients.config.'+a];
                    }
                }
            },
            '.login-field-place-custom':{
                text:{
                    data:'model.config_login_field_type',
                    processor:function(a) {
                        return LANGUAGE['clients.config.'+a];
                    }
                }
            }
        },
        events:{
            "click .action-button":"doAction",
            "click .add-property":"addNewProperty",
            "click .add-oauth-service":"addOAuthService",
            "click .config-service-modal .btn-primary":"onModalSaveClick",
            "click .do-delete-choiced-model":"onDoDeleteClick"
        },
        groups:[],
        config_login_field_type:null,
        props:[],
        handlers:{
            customselect:{
                get: function ($el, value) {
                    $el.trigger('change');
                    if ($el.val() !== value) {
                        $el.find("option[selected]").removeAttr("selected");
                        $el.find("option[value="+value+"]").attr("selected","selected");
                        $el.val(value);
                    }
                    $el.selectpicker('refresh');
                },
                set: function ($el) {
                    $el.selectpicker('refresh');
                    return $el.val();
                }
            },
            valueCustom: {
                get: function ($el, value) {
                    if ($el.val() !== value) {
                        $el.val(value).trigger('change');
                        $el[0].fpp.refreshPicker();
                    }
                },
                set: function ($el) {
                    return $el.val();
                }
            }
        },
        initialize:function(options) {
            document.addEventListener('wheel', this.processScroll.bind(this), {
                capture: true,
                passive: true
            });
            this.orders =0 ;
            this.$el.html(Template7.compile(template)());
            this.$el.find('[data-toggle="tooltip"]').tooltip();

            this.$modal = $(this.$el.find(".config-service-modal")[0]);

            //modal
            this.modal = new Backbone.Ribs.Model({
                title:'',
                action:'',
                enabled: false,
                auto_login:false
            });

            this.service = new Backbone.Ribs.Model({
                id:null,
                type:'',
                secret:'',
                key:'',
                active:false
            });

            this.opts=new Backbone.Ribs.Model(options);
            this.model=new configModel(options.model || {});
            this.olangs = options.languages;
            this.languages = new Backbone.Ribs.Collection(options.languages, { model:Backbone.Ribs.Model});
            this.props = new Backbone.Ribs.Collection(this.model.get("properties"), { model: propertyModel });
            var groups = {};
            for(var i=0;i<this.props.length;i++) {
                if(this.props.models[i].attributes.type == 'group') {
                    groups[this.props.models[i].attributes.id] = this.props.models[i].attributes;
                }
            }
            console.log("GROUPS",groups);
            this.groups = groups;

            this.props.languages = this.languages;
            this.props.cmodel = this.model;
            this.opts.set('plen', this.props.length);
            this.services = new Backbone.Ribs.Collection(this.model.get('services'), { model: Backbone.Ribs.Model});
            this.services.on("add reset remove pack-data", function(){
                var servs = [];
                for(var i=0;i<this.services.length;i++) {
                    servs.push(_.clone(this.services.models[i].attributes));
                }
                console.log('services',servs);
                this.model.set('services',servs).trigger('change:services').trigger('change');
            }.bind(this));
            this.services.on('open-modal', this.openModelEdit.bind(this));
            this.modal.set('enabled', !!this.services.length);
            this.props.onEdit = this.onEditProp.bind(this);
            this.props.onDelete = this.onDeleteClick.bind(this);

            this.props.on('add remove change', function() {
                var props = [];
                var groups = {};
                for(var i=0;i<this.props.length;i++) {
                    props.push(this.props.models[i].attributes);
                    if(this.props.models[i].attributes.type == 'group') {
                        groups[this.props.models[i].attributes.id] = this.props.models[i].attributes;
                    }
                }
                console.log("GROUPS",groups);
                this.groups = groups;
                this.pmodal.resetGroup(groups);
                this.model.set('properties', props);
                this.opts.set('plen', props.length);

                this.$el.find(".props-table-place-list .super-table-rows").sortable('refresh');
                _.defer(function(){
                    this.reordercol();
                }.bind(this));

            }.bind(this));

            this.customLoginFieldForm = new LanguageForm({
                el: this.$el.find('.custom-login-field-language-place')[0],
                model: this.model,
                field: 'custom_login_field',
                languages: this.languages
            });

            this.config_login_field_type = new Backbone.Ribs.Collection([
                {id:'email',  value: LANGUAGE['clients.config.email']},
                {id:'phone',  value: LANGUAGE['clients.config.phone']},
                {id:'custom', value:LANGUAGE['clients.config.custom']},
            ], {model:Backbone.Ribs.Model});
/*
            this.config_login_field_type.on("add reset remove", function(){
                setTimeout(500, function() {
                    $(".bootstrap-select").selectpicker('refresh');
                });
            });*/


            new SelectPicker({el: this.$el.find('select[name=config_login_field_type]')[0], collection: this.config_login_field_type, model:this.model, field:'config_login_field_type'});

            this.avail_oauth_services = new Backbone.Ribs.Collection(options.services);

            console.log(this.model.attributes);
            this.model.on("change", function() {
                console.log(this.model.attributes);
            }.bind(this));

            new ConfigureMessageTab({el: this.$el.find('#tab_messages')[0], model: this.model, languages:options.languages});

            this.pmodel = new propertyModel();
            this.pmodel.on("change", function() {
                console.log('TESTMODEL', this.pmodel.attributes);
            }.bind(this));

            this.pmodal = new PropertyModal({model:this.pmodel, languages: this.olangs, onsave: this.fromModalEvent.bind(this), onupdate: this.fromModalEvent.bind(this)});
            this.pmodal.resetGroup(groups);
            this.model.on("change",_.bind(this.updateValidate,this));
            this.$el.removeClass("loading");
            initFontPicker();
            var adjustment = 0;
            var cheight = 0;
            //add sorting
            this.$el.find(".props-table-place-list .super-table-rows").sortable({
                  //group: 'prop-drag-drop',
                //pullPlaceholder: true,
                 handle: ".drag",
                //placeholder:"list-group-item media super-menu-drag higlight",
                // animation on drop
                itemSelector:'li.st-row',
                onDrop: function  ($item, container, _super) {
                    var $clonedItem = $('<li class="placeholder"/>').css({height: cheight});

                    $item.before($clonedItem);

                    $clonedItem.animate({'opacity': 0});

                    $item.animate($clonedItem.position(), function  () {
                        $clonedItem.detach();
                       // $clonedItem.remove();
                        _super($item, container);
                    });
                    //update positions
                    this.reordercol();
                }.bind(this),

                // set $item relative to cursor position
                onDragStart: function ($item, container, _super) {
                    var offset = $item.offset(),
                        pointer = container.rootGroup.pointer;
                    cheight = $item.height();

                    adjustment = pointer.top-offset.top;
                    _super($item, container);
                },
                onDrag: function ($item, position,_super) {
                    position.left=-15;
                    position.top-=adjustment;
                    /*$item.css({
                        left: 0,
                        top: position.top - adjustment.top
                    });*/
                    _super($item,position);
                }
            });
        },
        addModalProp:function() {
            var attrs = _.clone(this.pmodel.attributes);
            attrs.order = this.orders++;
            attrs.id = null;
            console.log('add', attrs);
            this.props.add(attrs);
            this.pmodel.reset();
        },
        cedit:null,
        onEditProp:function(model) {
            this.cedit = model;
            console.log('onedit',model.attributes);
            this.pmodel.set(_.clone(model.attributes));
            this.pmodal.show();
        },
        updateModalProp:function() {
            this.cedit.set(_.clone(this.pmodel.attributes));
            this.cedit = null;
            this.pmodel.reset();
        },
        updateValidate:function() {

        },
        fromModalEvent: function() {
            if(this.cedit) {
                this.updateModalProp();
            }else{
                this.addModalProp();
            }
        },
        addNewProperty:function() {
            this.pmodel.reset();
            this.pmodal.show();
            this.cedit = null;
        },
        doAction:function() {
            this.$el.addClass("loading");
            var opts=JSON.parse(JSON.stringify(this.model.attributes));
            opts._token=this.opts.get("csrf");
            opts._method="POST";
            $.post(this.opts.get("storeurl"),opts,_.bind(function(response) {
                if(response.success) {
                    window.location=this.opts.get("backurl");
                    return;
                }
                this.$el.removeClass("loading");
                alert("Error");
            },this));
            return false;
        },
        processScroll:function() {

            var offset = this.$el.find(".default-properties-list").offset().top - 80;
            if(!this.$el.find(".default-properties-list").closest('#tab_propsex').hasClass("active")) {
                this.$el.find('.default-properties-list h5').removeClass('active').css("top","0"); return false;
            }

            if(offset < window.scrollY) {
                requestAnimationFrame(function() {
                    this.$el.find('.default-properties-list h5').addClass('active').css("top", window.scrollY-offset-80 );
                } .bind(this));
            }else{
                this.$el.find('.default-properties-list h5').removeClass('active').css("top","0");
            }
        },
        addOAuthService:function() {
            this.modal.set({
                title: _L('clients.config.form.service.title'),
                action: _L('basic.apply')
            });
            this.$modal.modal('show');
            return false;
        },
        callcb:null,
        openModelEdit:function(model, cb) {
            this.service.set(model.attributes);
            this.modal.set({
                title: _L('clients.config.oauth.service.'+model.attributes.oauth) + ' ' + _L('clients.config.form.service.title'),
                action: _L('basic.apply')
            });
            this.$modal.modal('show');
            this.callcb = cb;
        },
        onModalSaveClick: function() {
            this.$modal.modal('hide');
            if(this.callcb) {
                this.callcb(this.service);
            }
            return false;
        },
        dmodel:false,
        onDeleteClick: function(model) {
            this.dmodel = model;
            console.log('delete', model.attributes);
            this.$el.find(".delete-modal").modal('show');
        },
        onDoDeleteClick: function() {
            this.$el.find(".delete-modal").modal('hide');
            if(this.dmodel) {
                this.props.remove(this.dmodel);
                //this.props.trigger('change');
                //this.props.reset(this.model.get('properties'));
                this.dmodel = null;
            }
            return false;
        },
        reordercol: function() {
            var norder = 0;
            this.$el.find(".props-table-place-list .super-table-rows .st-row").each(function(i, item){
                var id = $(item).attr("data-id");
                console.log(id);
                var m = this.props.get(id);
                console.log(m);
                if(m) {
                    m.set('order', norder);
                }
                norder++;
            }.bind(this));
        }
    });
});

